/** Playback volume (0–1) shared by server audio and browser speech */
let volume = 1;

export function getVolume(): number {
  return volume;
}

export function setVolumeLevel(v: number): void {
  volume = Math.max(0, Math.min(1, v));
}
